
import { Component, Vue } from 'vue-property-decorator';
import { faceLocale } from '@/utils/faceDict';
// 目前不使用对应的表情，所以对应滚动条的组件功能也不需要增加
import OverlayScrollbars from 'overlayscrollbars';
import 'overlayscrollbars/css/OverlayScrollbars.css';
@Component({
  name: 'ChatFace',
})
class ChatFace extends Vue {
    faceLocale = faceLocale;
    currentTipName ='';
    tipTop=0;
    tipLeft=0;
    hiddenTip = true;
    osInstance:any  = null;
    changeCurrentTip(e:any, title:any) {
      this.currentTipName = title;
      this.tipTop = e.pageY + 20;
      this.tipLeft = e.pageX + 10;
      setTimeout(() => {
        this.hiddenTip = false;
      }, 200);
    }
    outCurrentTip() {
      this.currentTipName = '';
      this.hiddenTip = true;
    }
    moveCurrentTip(e:any) {
      this.tipTop = e.pageY + 20;
      this.tipLeft = e.pageX + 10;
    }
    clickFaceItem(title: any) {
      this.$emit('clickFaceItem', `[${title}]`);
    }
    mounted() {
      const element:any = this.$el.querySelector('.nano-content');
      this.osInstance = OverlayScrollbars(element, {});
      OverlayScrollbars.valid(this.osInstance);
    }
    destroyed() {
      if (this.osInstance) {
        this.osInstance.destroy();
        this.osInstance = null;
      }
    }
}
export default ChatFace;
